import React, { Fragment, ReactElement } from 'react';
import { Trans } from 'react-i18next';
import { Box, Typography } from '@vp/swan';
import { usePriceContext } from 'src/hooks/PriceContextHooks';
import { useProductContext } from 'src/hooks/ProductContextHooks';
import { text } from 'src/utils/localizationUtil';
import { PriceDisplay } from './PriceDisplay';

export type PricingInformationProps = {
  isMobile: boolean;
};

const PricingInformation = ({ isMobile }: PricingInformationProps): ReactElement => {
  const { price } = usePriceContext();
  const { productInformation } = useProductContext();

  if (!price) {
    return <Fragment />;
  }

  return (
    <Box marginTop={isMobile ? '5' : '0'} mb={7} style={{ whiteSpace: 'normal' }}>
      <Typography
        fontWeight="normal"
        fontSize={isMobile ? 'xsmall' : 'standard'}
        style={{ display: 'inline-block' }}
        marginRight={3}
      >
        <Trans i18nKey="starting-at-price" values={{ quantity: productInformation.quantity }}>
          {text('pricing-starting-text')}
          <PriceDisplay price={price} priceIsLoaded />
        </Trans>
      </Typography>
    </Box>
  );
};

export default PricingInformation;
